import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid } from '../../AgGrid';
import classnames from 'classnames';
import { getAllAPIUsers } from '../../../services/apiUser.service';

const styles = theme => ({});

export const APIUserGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Account Status', field: 'accountStatus' },
    { headerName: 'E-mail', field: 'email' },
    { headerName: 'Username', field: 'userName' },
    { headerName: 'ID', field: 'apiUserId', hide: true },
  ];

  const gridOptions = {};

  const getAllAPIUsersAsync = async () => {
    try {
      const data = await getAllAPIUsers();
      setGridData(data);
    } catch (err) {
      //do nothing
    }
  };

  useEffect(() => {
    getAllAPIUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        editOnClick={false}
        handleCellClick={evt => {
          // console.log('Clicked row data:', evt.data); // Temporary log to see what fields are available
          const apiUserId = evt.data.apiUserId;
          if (apiUserId) {
            window.location = `${window.location.href}/${apiUserId}`;
          } else {
            // do nothing console.error('No user ID found in row data:', evt.data);
          }
        }}
      />
    </div>
  );
}); 